import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ManualPreadviceTransactionsCreateDialog from './ManualPreadviceTransactionsCreateDialog';

class ManualPreadviceTransactionsCreate extends Component {
  render() {
    return (
      <div>
        <ManualPreadviceTransactionsCreateDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
        />
      </div>
    );
  }
}

ManualPreadviceTransactionsCreate.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
};

export default ManualPreadviceTransactionsCreate;
